import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './HVAC.scss';
import { useLocation, useNavigate } from "react-router-dom";
import Faq from "react-faq-component";
// images
import AreaData from './AreaData'
import LocationReviewsData from './LocationReviewsData'
import ReactCompareImage from "react-compare-image";
import BookAnAppointment from "../BookAnAppointment/BookAnAppointment";
import emailjs from 'emailjs-com';
import img22 from '../../Images/hvac-before.png'
import img23 from '../../Images/hvac-after.png'

export default function HVAC({ CitiePhone, locationsMain, CitiesData }) {

    const [Service, setService] = useState(true);
    const location = useLocation()
    const navigate = useNavigate()
    const [FormSubmiting, setFormSubmiting] = useState(false);
    const [response, setResponse] = useState({});
    const url = new URL(window.location.href);
    function sendEmail(e) {
        // setFormSubmiting(true)
        setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        emailjs.sendForm('service_fqud6um', 'template_vdkxpnd', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                setFormSubmiting(false)
                navigate(`/thankscontact?url=${location.pathname + location.search}`)
            }, (error) => {
                console.log(error.text);
            });
    }
    // Faqs
    const data = {
        title: "",
        rows: [
            {
                "title": "WHY CHOOSE AttiAir?",
                "content": "AttiAir is trusted for reliable HVAC repair and installation across the region. We bring years of hands-on experience, certified technicians, and a commitment to honest, high-quality service. From emergency fixes to full system installs, we’ve got you covered."
            },
            {
                "title": "WHAT SERVICES DO YOU OFFER?",
                "content": "We provide complete HVAC solutions, including AC and furnace repair, full system installation, air duct services, diagnostics, maintenance, and emergency HVAC support for both residential and commercial properties."
            },
            {
                "title": "HOW MUCH DO YOUR SERVICES COST?",
                "content": "Our repair services start at $79, and new HVAC system installations are quoted based on system type and home size. We offer free on-site consultations and upfront pricing with no hidden fees."
            },
            {
                "title": "DO YOU OFFER SAME-DAY HVAC REPAIRS?",
                "content": "Yes! We provide same-day HVAC repair for urgent issues like no heating or cooling, short-cycling, or airflow problems. Our team arrives with the tools and parts needed to resolve most issues on the spot."
            },
            {
                "title": `DO YOU PROVIDE SERVICES IN ${CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "YOUR AREA"}?`,
                "content": `Absolutely — we proudly serve ${CitiesData && CitiesData.City ? CitiesData.City : "your area"} and surrounding areas within a 75-mile radius. Whether you need HVAC repair or installation, we’re just a call away.`
            },
            {
                "title": "HOW DO I BOOK AN APPOINTMENT?",
                "content": `Booking is quick and easy. Just call <a href='tel:${CitiePhone}'>${CitiePhone}</a> or use our <a href='#book'>online booking form</a>. We’ll confirm the best time and send a technician to your location.`
            },
            {
                "title": "WHEN SHOULD I REPLACE MY HVAC SYSTEM?",
                "content": "Most systems last 10–15 years. If you're facing frequent breakdowns, rising energy bills, or uneven temperatures, it may be time for a replacement. We’ll assess your system and provide honest recommendations."
            },
            {
                "title": "WHY IS PROFESSIONAL HVAC INSTALLATION IMPORTANT?",
                "content": "A proper HVAC installation ensures energy efficiency, safety, and long-term performance. Our licensed team installs ACs, furnaces, and full systems according to manufacturer standards and local codes."
            }
        ]
    };


    const styles = {
        bgColor: '#f3f3f3',
        titleTextColor: '#222222',
        titleTextSize: '18px',
        rowTitleColor: '#222222',
        rowTitleTextSize: '19px',
        rowContentColor: '#242424',
        rowContentTextSize: '17px',
        // rowContentTextWeight: '600',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '10px',
        rowContentPaddingLeft: '5px',
        rowContentPaddingRight: '5px',
        arrowColor: "",
        //transitionDuration: "1s",
        // timingFunc: "ease"
    };
    const config = {
        // animate: true,
        // arrowIcon: "V",
        // tabFocus: true
        openOnload: 0,
    };

    useEffect(() => {
        (async () => {
            try {
                const searchKeyword = `I need from you 32 words about the "${url.searchParams.get('kd')}" how we "AttiAir" can help our clients with that kind of service, give me that as json file: title 3 words (include in the title words from the keyword, remove null and AttiAir from title)(if no keywords just do for HVAC Vent) and body`
                const apiKey = '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'; // Replace with your actual API key
                const resChat = await fetch(`https://api.openai.com/v1/chat/completions`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiKey}`,
                    },
                    body: JSON.stringify({
                        'model': 'gpt-3.5-turbo',
                        'messages': [
                            {
                                'role': 'user',
                                'content': searchKeyword
                            }
                        ]
                    })
                })
                const dataChat = await resChat.json()

                setResponse(JSON.parse(dataChat.choices[0].message.content))
            } catch (error) {
                console.log(error);
            }

            const getDerivedStateFromError = (error) => {
                console.log("123123");
                return { hasError: true };
            }
            const dsad = (error, errorInfo) => {
                console.log("123123");
            }
        })();
    }, []);
    return (
        <div className="HVAC" id="homepage">
            <Helmet>
                {/* <!-- TITLE (Max 65 characters) --> */}
                <title>AttiAir - Full HVAC Services | Repair, Installation & Maintenance | 866-257-5796</title>

                {/* <!-- META TITLE (Max 35 characters) --> */}
                <meta name="title" property="title" content="AttiAir - Full HVAC Services | Repair, Installation & Maintenance | 866-257-5796" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="AttiAir - Full HVAC Services | Repair, Installation & Maintenance | 866-257-5796" data-react-helmet="true" />

                {/* <!-- META DETAILS --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="website" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="https://www.attiair.com/images/HVACvent-og.jpg" data-react-helmet="true" />
                <meta name="og:url" property="og:url" content="https://www.attiair.com/HVAC-vent-cleaning" data-react-helmet="true" />

                {/* <!-- META DESCRIPTION (Max 155 characters, First Letter Uppercase) --> */}
                <meta
                    name="description"
                    content="AttiAir Offers Complete HVAC Services Including Repair, Installation, Maintenance, And Emergency Support For Homes And Businesses Across The Region."
                    data-react-helmet="true"
                />
                <meta
                    name="og:description"
                    property="og:description"
                    content="AttiAir Offers Complete HVAC Services Including Repair, Installation, Maintenance, And Emergency Support For Homes And Businesses Across The Region."
                    data-react-helmet="true"
                />

                <meta name="og:site_name" property="og:site_name" content="AttiAir" data-react-helmet="true" />

                {/* <!-- KEYWORDS --> */}
                <meta
                    name="keywords"
                    content="HVAC Repair, HVAC Installation, Emergency HVAC Services, HVAC Maintenance, AC Repair, Furnace Installation, HVAC Services Near Me, Air Conditioning Experts, Same Day HVAC Help, Energy Efficiency, HVAC Technicians, Residential HVAC, Commercial HVAC"
                    data-react-helmet="true"
                />
            </Helmet>


            {/* HVACMainBanner */}
            <div className="HVACMainBanner">
                <div className="HVACMainBannerTopLine">
                    <div className="HVACMainBannerTopLineLine"></div>
                    <div className="HVACMainBannerTopLineDot"></div>
                    <h1>HVAC REPAIR & INSTALLATION</h1>
                </div>

                <div className="HVACMainBannerTop">
                    <img src={require(`../../Images/hvac-1.png`)} />
                    <img src={require(`../../ImagesLogos/Logo1.png`)} className="bannerlogohere" />
                    <div className="HVACMainBannerTopLEFT"></div>
                </div>

                <div className="HVACMainBannerBottom">
                    <div className="HVACMainBannerBottomLeft">
                        <h1>Reliable AC & HVAC Repair, Replacement, and Tune-Ups In {CitiesData && CitiesData.City ? CitiesData.Full : "Your Area"}</h1>
                        <h2>
                            Fast AC Repairs • Expert Furnace Installations • Emergency HVAC Services In {CitiesData && CitiesData.City ? CitiesData.Full : "Your Area"}
                        </h2>

                        <div className="HVACMainBannerBottomLeftBtns">
                            <a target="_blank" href={`tel:${CitiePhone}`}>Call Us Now</a>
                            <a target="_blank" href={`tel:${CitiePhone}`}>{CitiePhone}</a>
                        </div>

                        <h4>AC, HEATING & HVAC SYSTEM SOLUTIONS In {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</h4>
                        <div className="HVACMainBannerBottomLeftLine"></div>

                        <p>
                            Need help with a broken AC, heating issue, or full HVAC replacement? AttiAir is your go-to team for
                            professional air conditioner repair, heating system installation, and seasonal maintenance. We fix, replace, and tune-up it all.
                        </p>

                        <p>
                            If your system isn't cooling or heating efficiently, or you’re searching for “AC repair near me” or
                            “HVAC service near me,” we've got you covered. AttiAir delivers expert solutions with honest pricing,
                            fast turnaround, and dependable 24/7 emergency HVAC support.
                        </p>

                        <div className="MainBannerLeftRatedMain">
                            <div className="Header2Location">
                                <img src={require(`../../Images/place.png`)} alt="" />
                                <h6>{CitiesData.City ? CitiesData.City.toUpperCase() : "Local"}</h6>
                            </div>

                            <div className="MainBannerLeftRated">
                                <h3>Rated 4.9 on Google</h3>
                                <span>
                                    <h4>4.9</h4>
                                    <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="HVACMainBannerBottomRight">
                        <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
                        <img src={require(`../../Images/banner55.jpeg`)} />
                        <h3>
                            <img src={require(`../../Images/stars.png`)} alt="Locally Owned & Operated" />
                            Locally Owned & Operated
                        </h3>
                        <h3>
                            <img src={require(`../../Images/stars.png`)} alt="Certified | Licensed | Insured" />
                            Certified | Licensed | Insured
                        </h3>
                        <h3>
                            <img src={require(`../../Images/stars.png`)} alt="Satisfaction Guaranteed" />
                            Satisfaction Guaranteed
                        </h3>
                    </div>
                </div>
            </div>

            {/* HVACMainBannerService */}
            <div className="HVACMainBannerService">
                <div className="HVACMainBannerServiceMenu">
                    <div className="HVACMainBannerServiceMenuBox" style={Service ? { "backgroundColor": "white", "borderTop": "8px solid #fcb116" } : { "backgroundColor": "#e4e4e4", "borderTop": "8px solid #fcb116" }} onClick={() => setService(a => true)}>
                        <h1>HVAC REPAIR</h1>
                    </div>
                    <div className="HVACMainBannerServiceMenuBox" style={!Service ? { "backgroundColor": "white", "borderTop": "8px solid #fcb116" } : { "backgroundColor": "#e4e4e4", "border-top": "8px solid #fcb116" }} onClick={() => setService(a => false)}>
                        <h1>HVAC INSTALLATION</h1>
                    </div>
                </div>
                {Service ?

                    <div className="HVACMainBannerServiceInfo">
                        <div className="HVACMainBannerServiceInfoTop">
                            <div className="HVACMainBannerServiceInfoLeft">
                                <h1>HVAC REPAIR SERVICE</h1>
                                <img src={require(`../../Images/hvac-7.jpg`)} />
                            </div>
                            <div className="HVACMainBannerServiceInfoRight">
                                <div className="HVACBenefitsBox">
                                    <div className="HVACBenefitsBoxImg">
                                        <img src={require(`../../Images/ben2.png`)} alt="No Airflow" />
                                    </div>
                                    <div className="HVACBenefitsBoxBox">
                                        <h2>Rooms Not Cooling or Heating?</h2>
                                        <h3>Uneven temperatures or weak airflow could mean your HVAC system needs repair. We diagnose and fix the issue quickly to restore comfort throughout your home.</h3>
                                    </div>
                                </div>

                                <div className="HVACBenefitsBox">
                                    <div className="HVACBenefitsBoxImg">
                                        <img src={require(`../../Images/ben3.png`)} alt="HVAC Overheating" />
                                    </div>
                                    <div className="HVACBenefitsBoxBox">
                                        <h2>Strange Noises or Smells?</h2>
                                        <h3>If your system makes loud noises or gives off a burning smell, it could be a sign of serious damage. Our HVAC repair team will inspect and repair the unit safely and efficiently.</h3>
                                    </div>
                                </div>

                                <div className="HVACBenefitsBox">
                                    <div className="HVACBenefitsBoxImg">
                                        <img src={require(`../../Images/ben1.png`)} alt="High Utility Bills" />
                                    </div>
                                    <div className="HVACBenefitsBoxBox">
                                        <h2>Spike in Energy Bills?</h2>
                                        <h3>Malfunctioning HVAC systems use more energy to deliver less comfort. Our repairs restore system performance and help lower your monthly utility costs.</h3>
                                    </div>
                                </div>

                                <div className="HVACBenefitsBox">
                                    <div className="HVACBenefitsBoxImg">
                                        <img src={require(`../../Images/ben4.png`)} alt="HVAC Short Cycling" />
                                    </div>
                                    <div className="HVACBenefitsBoxBox">
                                        <h2>System Turning On and Off Constantly?</h2>
                                        <h3>Short cycling can wear out your HVAC system and reduce efficiency. We repair the root cause—whether electrical, thermostat-related, or airflow—to get it running smoothly again.</h3>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="BookAnAppointmentMainComponentEmergeryBox">
                            <a target='_blank' href={`tel:${CitiePhone}`}>For emergency service Call: <span>{CitiePhone}</span></a>
                        </div>
                        {/* MainBanner2Top2 */}
                        <div className="MainBanner2Top2" id="ourservices">
                            <div className="MainBanner2TopBox">
                                <div className="MainBanner2TopBoxBack">
                                    {/*  */}
                                </div>
                                <div className="MainBanner2TopBoxMain">
                                    <h2>OUR HVAC SERVICES</h2>
                                    <div className="MainBanner2TopBoxMenu">
                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/aircleaning.png`)} alt="HVAC System Diagnosis" />
                                            <h3>HVAC System Diagnosis</h3>
                                            <h4>Find the Root of the Problem</h4>
                                            <h2>We thoroughly inspect your HVAC system to identify electrical issues, airflow problems, or faulty components.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/airdryer.png`)} alt="HVAC Component Repair" />
                                            <h3>HVAC Component Repair</h3>
                                            <h4>Fix Motors, Fans, and Wiring</h4>
                                            <h2>Our technicians repair worn-out motors, damaged wiring, failed capacitors, and more to restore full system function.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/airinspection.png`)} alt="Thermostat & Sensor Repair" />
                                            <h3>Thermostat & Sensor Repair</h3>
                                            <h4>Accurate Control & Comfort</h4>
                                            <h2>We replace or recalibrate faulty thermostats and sensors to improve accuracy and eliminate short-cycling.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/airrepair.png`)} alt="Airflow & Duct Repair" />
                                            <h3>Airflow & Duct Repair</h3>
                                            <h4>Restore Balanced Air Circulation</h4>
                                            <h2>We fix airflow issues caused by disconnected or leaking ductwork and restore balanced comfort to every room.</h2>
                                        </a>
                                    </div>
                                    <div className="MainBanner2TopBoxMainChat">
                                        <img src={require(`../../ImagesLogos/Logo2.png`)} />
                                        <div className="MainBanner2TopBoxMainChatText">
                                            <h4>{response.title}</h4>
                                            <h3>{response.body}</h3>
                                            <h5>Call us at <a href={`tel:${CitiePhone}`}>{CitiePhone}</a> or fill out the <a href={`/book${location.search}`}>online form</a> to schedule your visit.</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="HVACMainBannerServiceInfo">
                        <div className="HVACMainBannerServiceInfoTop">
                            <div className="HVACMainBannerServiceInfoLeft">
                                <h1>HVAC INSTALLATION SERVICE</h1>
                                <img src={require(`../../Images/hvac.webp`)} />
                            </div>
                            <div className="HVACMainBannerServiceInfoRight">
                                <div className="HVACBenefitsBox">
                                    <div className="HVACBenefitsBoxImg">
                                        <img src={require(`../../Images/ben2.png`)} alt="Old HVAC System" />
                                    </div>
                                    <div className="HVACBenefitsBoxBox">
                                        <h2>Old System Struggling to Keep Up?</h2>
                                        <h3>Is your current HVAC loud, unreliable, or running nonstop? It may be time for a full system replacement. We install high-efficiency units that deliver reliable comfort year-round.</h3>
                                    </div>
                                </div>

                                <div className="HVACBenefitsBox">
                                    <div className="HVACBenefitsBoxImg">
                                        <img src={require(`../../Images/ben3.png`)} alt="Hot or Cold Spots" />
                                    </div>
                                    <div className="HVACBenefitsBoxBox">
                                        <h2>Hot or Cold Spots in Your Home?</h2>
                                        <h3>Uneven temperatures often mean your system is outdated or improperly sized. We design and install new HVAC systems that distribute air evenly throughout your space.</h3>
                                    </div>
                                </div>

                                <div className="HVACBenefitsBox">
                                    <div className="HVACBenefitsBoxImg">
                                        <img src={require(`../../Images/ben1.png`)} alt="Frequent Repairs" />
                                    </div>
                                    <div className="HVACBenefitsBoxBox">
                                        <h2>Spending Too Much on Repairs?</h2>
                                        <h3>If you're constantly fixing your HVAC, it may be more cost-effective to install a new system. We offer reliable AC and furnace replacements built for long-term performance.</h3>
                                    </div>
                                </div>

                                <div className="HVACBenefitsBox">
                                    <div className="HVACBenefitsBoxImg">
                                        <img src={require(`../../Images/ben4.png`)} alt="High Energy Use" />
                                    </div>
                                    <div className="HVACBenefitsBoxBox">
                                        <h2>High Energy Bills Every Month?</h2>
                                        <h3>Older systems are often inefficient and expensive to run. Our modern HVAC installations are energy-efficient, saving you money on monthly utility costs.</h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="BookAnAppointmentMainComponentEmergeryBox">
                            <a target='_blank' href={`tel:${CitiePhone}`}>For emergency service Call: <span>{CitiePhone}</span></a>
                        </div>
                        {/* MainBanner2Top2 */}
                        <div className="MainBanner2Top2" id="ourservices">
                            <div className="MainBanner2TopBox">
                                <div className="MainBanner2TopBoxBack">
                                    {/*  */}
                                </div>
                                <div className="MainBanner2TopBoxMain">
                                    <h2>OUR HVAC INSTALL SERVICES</h2>
                                    <div className="MainBanner2TopBoxMenu">
                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/aircleaning.png`)} alt="AC Installation" />
                                            <h3>AC Installation</h3>
                                            <h4>Stay Cool All Year Long</h4>
                                            <h2>We install high-efficiency air conditioning systems tailored to your home's size, layout, and cooling needs.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/airdryer.png`)} alt="HVAC System Replacement" />
                                            <h3>HVAC System Replacement</h3>
                                            <h4>Upgrade for Comfort & Efficiency</h4>
                                            <h2>Replace your outdated system with a modern, energy-saving unit that delivers reliable heating and cooling.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/airinspection.png`)} alt="Furnace Installation" />
                                            <h3>Furnace Installation</h3>
                                            <h4>Reliable Heating When You Need It</h4>
                                            <h2>We install powerful gas or electric furnaces built for long-term comfort, performance, and safety.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/airrepair.png`)} alt="Ductwork Installation" />
                                            <h3>Ductwork Installation</h3>
                                            <h4>Optimized Airflow for New Systems</h4>
                                            <h2>We design and install ductwork layouts that ensure balanced airflow, energy efficiency, and quiet operation.</h2>
                                        </a>
                                    </div>

                                    <div className="MainBanner2TopBoxMainChat">
                                        <img src={require(`../../ImagesLogos/Logo2.png`)} />
                                        <div className="MainBanner2TopBoxMainChatText">
                                            <h4>{response.title}</h4>
                                            <h3>{response.body}</h3>
                                            <h5>Call us at <a href={`tel:${CitiePhone}`}>{CitiePhone}</a> or fill out the <a href={`/book${location.search}`}>online form</a> to schedule your visit.</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <h4>TAKE THE FIRST STEP TOWARD A HEALTHIER AND MORE <span>EFFICIENT HOME</span><br /> SCHEDULE YOUR Air Duct CLEANING TODAY!</h4>
                <div className="HVACBenefitsbutn">
                    <a href={`tel:${CitiePhone}`}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                    <a href='#book'>SCHEDULE <span>&nbsp;ONLINE</span><img src={require(`../../Images/book.png`)} alt="Air Duct Cleaning | Air Duct Repair | Air Duct Services | Air Duct Inspection In Master," /></a>
                </div>
            </div>

            {/* HVACGoodBY */}
            <div className="HVACGoodBY">
                <h1>SAY GOODBYE TO HVAC PROBLEMS FOR GOOD</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <h2>Enjoy reliable comfort, lower energy bills, and cleaner air with expert HVAC repair and installation from AttiAir.</h2>
                <div className="HVACGoodBYList">
                    <img src={require(`../../Images/hvac-4.png`)} />
                    <img src={require(`../../Images/hvac-5.png`)} />
                    <img src={require(`../../Images/hvac-6.jpg`)} />
                    <img src={require(`../../Images/hvac-7.jpg`)} />
                </div>
            </div>

            {/* HVACBefore */}
            <div className="HVACBefore">
                <div className="HVACBeforeLeft">
                    <h1>THE IMPORTANCE OF A HEALTHY HVAC SYSTEM</h1>
                    <h2>Restore Comfort, Save Energy & Improve Airflow</h2>
                    <h3>Your HVAC system is the backbone of indoor comfort. Over time, wear and tear, airflow restrictions, or outdated equipment can impact its ability to heat and cool effectively. Faulty parts, poor airflow, or aging systems not only reduce comfort but also increase energy use and repair costs. Whether you need a fast repair or a full system replacement, AttiAir helps keep your home efficient, safe, and comfortable year-round.</h3>
                    <h2>Why HVAC Repair & Installation Matters</h2>
                    <h3>
                        ✔ <b>Consistent Comfort</b> – Eliminate hot and cold spots with a properly balanced HVAC system.
                        <br />
                        ✔ <b>Lower Energy Bills</b> – Efficient repairs and new installations reduce waste and cut utility costs.
                        <br />
                        ✔ <b>Cleaner Indoor Air</b> – Improve airflow and ventilation to reduce allergens and contaminants.
                        <br />
                        ✔ <b>Longer System Life</b> – Address small issues before they turn into costly system failures.
                    </h3>
                    <h4>Booking with AttiAir is simple! Call us at <a href='tel:${CitiePhone}'>{CitiePhone}</a> or complete our <a href='#book'>online booking form</a>. Our team will confirm your appointment and be ready to assist you at your convenience.</h4>
                </div>
                <div className="HVACBeforeBox">
                    <ReactCompareImage leftImage={img22} rightImage={img23} />
                </div>
            </div>

            {/* HVACReviews */}
            <div className="HVACReviews">
                <div className="HVACReviewsHeader">
                    <h2>HVAC Repair & Installation Reviews:</h2>
                    <h1>Customers are feeling the difference</h1>
                    <div className="HVACReviewsHeaderLine"></div>
                </div>
                <div className="HVACReviewsMenu">
                    {LocationReviewsData.map((A, index) =>
                        <div key={index} className="HVACReviewsMenuBox">
                            <div className="HVACReviewsMenuBoxStars">
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                            </div>
                            <h1>{A.review}</h1>
                            <h2>{A.customer}</h2>
                        </div>
                    )}
                </div>
            </div>

            {/* HVACBook */}
            <div className="HVACBook" id="book">
                <div className="HVACReviewsHeader">
                    <h2>Easy & Convenient Booking:</h2>
                    <h1>Schedule Your Service Online!</h1>
                    <div className="HVACReviewsHeaderLine"></div>
                </div>
                <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
            </div>

            {/* MainBanner2Top2 */}
            <div className="HVACServices">
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <h3>HVAC REPAIR</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/hvac-3.png`)} alt="HVAC Repair" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Is your HVAC system not working properly? AttiAir offers fast, reliable HVAC repair services for ACs, furnaces, and full systems. Whether it’s a faulty fan, broken motor, or thermostat issue, our expert technicians diagnose and fix the problem quickly—restoring comfort and efficiency to your home.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />AC & Furnace Troubleshooting</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Motor, Fan & Capacitor Repairs</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Thermostat & Control Issues</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Same-Day HVAC Service</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>AC REPAIR</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/hvac-2.jpg`)} alt="AC Repair" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Is your AC blowing warm air or making strange noises? AttiAir’s expert AC repair team quickly diagnoses the issue and restores cool, consistent comfort to your home. From refrigerant leaks to faulty motors, we fix it fast—so you can breathe easy again.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Fast Cooling Restoration</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Refrigerant Leak Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Electrical & Motor Fixes</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />24/7 Emergency Availability</h2>
                            </div>
                        </div>
                    </a>



                    <a className="MainBanner2TopBoxBox">
                        <h3>HVAC MAINTENANCE / TUNE-UP</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/hvac-4.png`)} alt="HVAC Maintenance Tune-Up" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Keep your system running at its best with AttiAir’s expert HVAC maintenance and seasonal tune-ups. Our thorough inspections catch small issues before they turn costly, improve airflow, and help your unit last longer. Stay efficient, stay cool—schedule your HVAC checkup today!</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />System Efficiency Boost</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Full Safety Inspection</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Clog & Leak Detection</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Preventive System Care</h2>
                            </div>
                        </div>
                    </a>


                    <a className="MainBanner2TopBoxBox">
                        <h3>AC INSTALLATION / REPLACEMENT</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/hvac-8.jpeg`)} alt="AC Installation" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Upgrade your comfort with AttiAir’s professional AC installation and replacement services. Whether you're building new or replacing an outdated system, we provide energy-efficient solutions tailored to your home. Enjoy powerful cooling, lower energy bills, and a system you can rely on.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Energy-Efficient System Installation</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Smart Thermostat Setup</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Custom Sizing & Load Calculation</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Old Unit Haul-Away</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>FURNACE INSTALLATION / REPLACEMENT</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/hvac-5.png`)} alt="Furnace Installation" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Stay warm and efficient all winter long with AttiAir’s expert furnace installation and replacement services. Whether you're upgrading an old unit or setting up new construction, our team ensures a seamless installation with reliable heating and improved energy performance.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />High-Efficiency Furnace Options</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Precise Sizing & Installation</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Ductwork Compatibility Checks</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Old Unit Removal & Disposal</h2>
                            </div>
                        </div>
                    </a>


                    <a className="MainBanner2TopBoxBox">
                        <h3>EMERGENCY HVAC SERVICES</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/hvac-2.jpg`)} alt="Emergency HVAC Services" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Heating or cooling issue after hours? AttiAir offers 24/7 emergency HVAC services to restore comfort fast. Whether it's a breakdown during extreme weather or an unexpected issue, our expert technicians are always ready to respond promptly and professionally.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />24/7 Rapid Response</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Emergency Diagnostics & Repairs</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Fully Equipped Mobile Units</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Immediate Comfort Restoration</h2>
                            </div>
                        </div>
                    </a>

                </div>

            </div>

            {/* HomePageGoogleFAQ */}
            <div className="HomePageGoogleFAQ">
                <h1>ABOUT OUR {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : ""} LOCATION</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="HomePageGoogleFAQTop">
                    <div className="HomePageGoogleFAQTopLeft">
                        <h2>PROUDLY SERVING OUR LOCAL COMMUNITY</h2>
                        <div className="HomePageGoogleFAQBorder"></div>
                        <h3>At AttiAir, we are dedicated to providing exceptional service to our community. For over 22 years, we have committed ourselves to delivering top-quality HVAC Vent cleaning services over {CitiesData && CitiesData.City ? CitiesData.City : ""}, ensuring healthier and more comfortable living environments. In addition to HVAC Vent cleaning, we also offer a range of services tailored to improve indoor air quality and meet the unique needs of our valued customers.</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                            <a href='#book'>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Sweep Cleaning Near Me AttiAir" /></a>
                        </div>
                    </div>
                    <div className="HomePageGoogleFAQTopRight">
                        <img src={require(`../../ImagesLogos/logobanner.png`)} />
                    </div>
                </div>
                <h1>FREQUENTLY ASKED QUESTIONS</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="MainBanner4FaqMore">
                    <Faq
                        data={data}
                        styles={styles}
                        config={config}
                    />
                </div>
            </div>
        </div>
    )
}

